"use client";

import {
  Content,
  DropdownMenu,
  DropdownMenuContentProps,
  DropdownMenuProps,
  Portal,
  Trigger,
} from "@radix-ui/react-dropdown-menu";
import { ReactElement } from "react";

import { cn } from "../../utils";
import styles from "./Dropdown.module.scss";

export interface DropdownProps
  extends DropdownMenuProps, DropdownMenuContentProps {
  trigger: ReactElement;
}

export const Dropdown: React.FC<DropdownProps> = ({
  dir,
  open,
  modal,
  trigger,
  children,
  className,
  defaultOpen,
  onOpenChange,
  ...contentProps
}) => {
  return (
    <DropdownMenu
      dir={dir}
      open={open}
      modal={modal}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
    >
      <Trigger asChild className="ui:outline-none">
        {trigger}
      </Trigger>

      <Portal>
        <Content
          {...contentProps}
          className={cn(styles.DropdownMenuContent, className)}
        >
          {children}
        </Content>
      </Portal>
    </DropdownMenu>
  );
};
